import universalCookie from 'universal-cookie'

import parseAccountInformation from './parseAccountInformation'

// TODO: ask BE to handle this
export default function getAccountInformation() {
  const cookies = new universalCookie()
  const accountBase64 = cookies.get('ACCOUNT') as unknown

  if (accountBase64 && typeof accountBase64 === 'string') {
    return parseAccountInformation(accountBase64)
  }
}
